export const userList = {
  gap: "2",
  cursor: "pointer",
  align: "center",
  p: "2",
  borderRadius: "12px",
  _hover: { bg: "gray.100" },
  justifyContent: "space-between",
};
